const ACTIVE_SIDEBAR_ITEM: string = 'ACTIVE_SIDEBAR_ITEM';

const TYPES: any= {
    ACTIVE_SIDEBAR_ITEM
};

export default TYPES;